import { ImageWithFallback } from "@/components/image-with-fallback/ImageWithFallback";
import type { EIcon } from "@/utils/enums";
import { getAssetUrl } from "@/utils/helpers";
import style from "./Icon.module.css";

type TIconProps = {
  name?: EIcon | undefined;
  url?: string;
  className?: string;
  fallback?: React.JSX.IntrinsicElements["img"]["src"];
} & React.JSX.IntrinsicElements["img"];

export const Icon = ({
  name,
  url,
  className,
  fallback,
  ...props
}: TIconProps) => {
  if (url)
    return (
      <div className={style.container}>
        <ImageWithFallback
          key={url}
          src={url}
          alt={`${name} icon`}
          className={`${style.image} ${className}`}
          fallback={fallback}
          {...props}
        />
      </div>
    );
  if (!name) return null;
  return (
    <ImageWithFallback
      key={getAssetUrl(`icons/${name}.svg`)}
      fallback={fallback}
      className={className}
      src={getAssetUrl(`icons/${name}.svg`)}
      alt={`${name} icon`}
      {...props}
    />
  );
};
